import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Children, Component } from 'react'

export default class Table extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    data: PropTypes.array.isRequired,
    rowRenderer: PropTypes.func,
    striped: PropTypes.bool,
    wrapInTbody: PropTypes.bool
  }

  static defaultProps = {
    striped: true,
    wrapInTbody: true
  }

  constructor(props) {
    super(props)

    this.renderHeader = this.renderHeader.bind(this)
    this.renderRow = this.renderRow.bind(this)
  }

  renderHeader(tableColumn) {
    if (!tableColumn) {
      return
    }

    const { align, dataKey, headerRenderer, label, width } = tableColumn.props
    const style = {
      textAlign: align
    }
    if (width) {
      style.width = width
    }

    return (
      <th key={dataKey} style={style}>
        {headerRenderer ? headerRenderer(label, dataKey) : I18n.t(label)}
      </th>
    )
  }

  renderColumn(rowData, tableColumn, index) {
    if (!tableColumn) {
      return
    }

    const { align, dataGetter, cellRenderer, dataKey } = tableColumn.props
    const cellData = dataGetter
      ? dataGetter(rowData, dataKey, index)
      : rowData[dataKey]

    return (
      <td key={dataKey} style={{ textAlign: align }}>
        {cellRenderer
          ? cellRenderer(cellData, rowData, dataKey, index)
          : cellData}
      </td>
    )
  }

  renderRow(rowData, index) {
    const { children } = this.props

    return (
      <tr key={index}>
        {Children.map(children, column =>
          this.renderColumn(rowData, column, index)
        )}
      </tr>
    )
  }

  renderRows() {
    const { data, rowRenderer } = this.props

    return data.map((rowData, index) =>
      rowRenderer
        ? rowRenderer(rowData, this.renderRow(rowData, index), index)
        : this.renderRow(rowData, index)
    )
  }

  render() {
    const { children, className, striped, wrapInTbody } = this.props
    const classes = classNames('table', className, {
      'table-striped': striped
    })

    return (
      <table className={classes}>
        <thead>
          <tr>{Children.map(children, this.renderHeader)}</tr>
        </thead>
        {wrapInTbody && <tbody>{this.renderRows()}</tbody>}
        {!wrapInTbody && this.renderRows()}
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Table.js